import Vue from "vue"

import ApolloClient from 'apollo-client';
import { HttpLink } from 'apollo-link-http';
import { ApolloLink, concat, split } from 'apollo-link';
import { InMemoryCache } from 'apollo-cache-inmemory'

import VueApollo from 'vue-apollo'

import config from './storefrontConfig'

Vue.use(VueApollo)

const link = new HttpLink({ uri: config.uri });

const authMiddleware = new ApolloLink((operation, forward) => {
  operation.setContext({
    headers: {
      'X-Shopify-Storefront-Access-Token': config.key
    } 
  });

  return forward(operation);
})


const defaultClient = new ApolloClient({
  link: concat(authMiddleware, link),
  cache: new InMemoryCache()
});

const apolloProvider = new VueApollo({
  defaultClient,
  errorHandler (error) {
    console.log('Global error handler')
    console.error(error)
  }
})

export default apolloProvider



// WEBPACK FOOTER //
// ../assets/js/personalize/storefront.js